import React, { Component } from 'react'
import SubjectsPV from './SubjectsPV'
import AuthA from '../../store/actions/AuthA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import moment from 'moment'
import {connect} from 'react-redux'

const _ = {
  sortBy: sortBy,
  find: find
}

class SubjectPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['name', 'code', 'subjectCategory', 'actions'],
      activePage: 1,
      itemPerPage: 10,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false,
      schoolYears: [],
      currentSchoolYear: '',
      schoolYearId: '',
      results: []
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.getSubject = this.getSubject.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  getSubject() {
    axios.get(process.env.REACT_APP_URL+'/subjects?filter[where][active]=true&filter[where][schoolYearId]='+this.state.schoolYearId)
    .then(response => {
      this.setState({ data: response.data, loaded: true });
    });
  }

  getSchoolYears() {
    axios.get(process.env.REACT_APP_URL+'/schoolyears?filter[where][active]=true')
    .then(response => {
      const currentSchoolYear = _.find(response.data, {
        isCurrent: true
      });
      this.setState({
        schoolYears: response.data,
        schoolYearId: currentSchoolYear.schoolYearId,
        currentSchoolYear: currentSchoolYear
      }, function(){
        this.getSubject();
      });
    });
  }

  isSearched(searchKey) {
    return function(item) {
      return (
        !searchKey ||
        item.name.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.code.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleFileChange(file) {
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: this.handleDataChange
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleRowClick(subject) {
    this.props.history.push(this.props.location.pathname+'/' + subject.subjectId);
  }

  handleDataSave() {
    // const content = fileReader.result;
    const data = this.state.results;
    let parsedSubject = {};

    let i = 0;
    for (i = 0; i < data.length; i++) {
      let code = data[i]['Name'].replace(/\s/g, '')
      code = code + '-' + moment().format('MMDDYYYY')

      parsedSubject = {
        name: data[i]['Name'],
        code: code.toUpperCase(),
        subjectCategory: data[i]['Category'],
        description: data[i]['Description'],
        schoolYearId: this.state.schoolYearId
      };
      const url = process.env.REACT_APP_URL+'/subjects';
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedSubject
        })
        .then(response => {
          // console.log(response.data)
        })
        .catch(err => console.log(err));
        // window.location.reload()
    }
    this.getSubject();
  }

  handleSubmit(data) {
    const url = process.env.REACT_APP_URL+'/subjects';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {this.getSubject()})
      .catch(err => console.log(err));
  }

  handleUpdate(data,id) {
    const url = process.env.REACT_APP_URL+'/subjects/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {this.getSubject()})
      .catch(err => console.log(err));
  }

  handleDelete(id) {
    const url = process.env.REACT_APP_URL+'/subjects/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getSubject()})
      .catch(err => console.log(err));
  }

  handleChange = (e, { value }) => {
    this.setState({ schoolYearId: value }, () => this.getSubject())
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'School Setup / Subject'});
    this.getSchoolYears();
  }

  render() {
    return (
      <SubjectsPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        schoolYears={this.state.schoolYears}
        currentSchoolYear={this.state.currentSchoolYear}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        schoolYearId={this.state.schoolYearId}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleDataSave={this.handleDataSave}
        handleFileChange={this.handleFileChange}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
        handleChange={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubjectPC);
